import { render, staticRenderFns } from "./BoardListVisitor.vue?vue&type=template&id=2de31202&scoped=true"
import script from "./BoardListVisitor.vue?vue&type=script&lang=js"
export * from "./BoardListVisitor.vue?vue&type=script&lang=js"
import style0 from "./BoardListVisitor.vue?vue&type=style&index=0&id=2de31202&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de31202",
  null
  
)

export default component.exports